import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

function useApplicantProfile(props) {
  const [userProfileInfo, setUserProfileInfo] = useState({});

  const { applicantProfileData } = useSelector(
    (state) => state.get_applicant_profile_info_reducer
  );

  useEffect(() => {
    if (applicantProfileData !== undefined) {
      setUserProfileInfo(applicantProfileData?.data);
    }
  }, [applicantProfileData]);

  return {
    userProfileInfo,
  };
}

export default useApplicantProfile;
